/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import moment from 'moment';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ExtendProjectMultiForm from './ExtendProjectMultiForm/ExtendProjectMultiForm';
import ExtendProjectMultiSuccess from './ExtendProjectMultiSuccess/ExtendProjectMultiSuccess';
import ExtendProjectMultiError from './ExtendProjectMultiError/ExtendProjectMultiError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
  projectDetailsStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class ExtendProjectMulti extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, projectDetailsStore }: TypeProps = this.props;
    const project: Object = this.props.project;

    const currentEndDate: Date = new Date(
      Math.max.apply(
        null,
        project.map(function(p) {
          return new Date(p.end_date);
        })
      )
    );

    const fields: Array<Object> = [
      {
        name: 'extendProjectForm',
        label: t('general:actions.extend_project_plural'),
        title: 'Extend Projects',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_extending_projects'),
            rules: 'required',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.projects_not_complete'),
              },
              {
                id: 2,
                label: t('general:reasons.options.customer_extended_projects_duration'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
          {
            name: 'endDate',
            label: t('general:projects.labels.new_end_date'),
            rules: 'date|required|after:' + moment(currentEndDate).format('YYYY-MM-DD'),
            value: moment(currentEndDate)
              .add(1, 'd')
              .format('YYYY-MM-DD'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const projectIds = project.map(p => p.id);

        const { reason, endDate } = data.values().extendProjectForm;

        actionDrawerStore.extendProjectMulti({
          extend_reason: reason,
          end_date: endDate,
          project_ids: projectIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.extend_project_plural'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.extend_project_plural')} />
          <ExtendProjectMultiError response={actionDrawerStore.errorResponse} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.extend_project_plural')} />
          <ExtendProjectMultiSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.extend_project_plural')} />
        <ExtendProjectMultiForm project={project} form={this.createForm()} />
      </div>
    );
  }
}
